<template>
  <div class="page-wrap text-center">
    <div
      class="session-form-hold"
      :style="{ maxWidth: !showForm ? '500px' : '550px' }"
    >
      <v-card rounded="xl">
        <ConcessionForm
          class="pa-1"
          v-if="showForm"
          @finished="finished"
        />
        <ConcessionViewController
          v-else
          :error="error"
          :loading="loading"
          :concession="concession"
          @showForm="showForm = true"
          @refresh="getConcession"
        />
      </v-card>
    </div>
    <RenewToken />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ACCOUNT from "../../../../services/account";
import ConcessionForm from "../../../../components/global/account/concession/ConcessionForm.vue";
import ConcessionViewController from "../../../../components/global/account/concession/ConcessionViewController.vue";
import RenewToken from "../../../../components/global/RenewToken.vue";
export default {
  name: "Concession",
  components: {
    ConcessionForm,
    ConcessionViewController,
    RenewToken,
  },
  metaInfo: {
    title: "Benefícios Meia Entrada",
  },
  data() {
    return {
      showForm: false,
      loading: false,
      concession: null,
      error: null,
    };
  },
  methods: {
    async getConcession() {
      try {
        this.loading = true;
        this.error = null;
        const data = await ACCOUNT.concession.get();
        this.concession = data.concession;
        this.$nextTick(() => {
          if (this.$route.query.init && this.concessionStatus.canApply)
            this.showForm = true;
        });
      } catch (error) {
        this.error =
          error.message || "Erro ao buscar benefícios de meia entrada";
      } finally {
        this.loading = false;
      }
    },
    finished() {
      this.getConcession();
      this.showForm = false;
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    concessionStatus() {
      if (!this.concession)
        return {
          canApply: true,
          message:
            "Você ainda não enviou para análise nenhuma solicitação de meia entrada.",
        };
      if (this.concession.status === "MANUAL_REVIEW")
        return {
          canApply: false,
          message: "Sua solicitação de meia entrada está em revisão manual.",
          showViewButton: true,
        };

      return {
        canApply: false,
        message: "Sua solicitação de meia entrada foi aprovada.",
      };
    },
  },
  mounted() {
    this.getConcession();
  },
};
</script>
<style lang="scss">
.page-wrap {
  background: radial-gradient(
      circle at 50% 50%,
      rgba(0, 0, 0, 50%) 0%,
      rgba(0, 0, 0, 90%) 90vw
    ),
    url(/img/logo/auth-background.png), black;
  display: flex;
  background-size: cover;
  background-position: center;
  align-items: center;
  padding: 40px 1rem;
  height: 100%;
  min-height: 100vh;
}
.session-form-hold {
  width: 100%;
  margin: 0 auto;
}

.opacity-transition {
  transition: opacity 0.3s;
}

.face-container {
  div {
    border-radius: 16px;
    svg {
      border-radius: 16px;
    }
  }
}
</style>
